import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoContaBancaria, cadastrarTipoContaBancaria, alterarTipoContaBancaria, excluirTipoContaBancaria } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposContasBancariasEditar = function () {
    var services = {
        getItem: getTipoContaBancaria,
        cadastrarItem: cadastrarTipoContaBancaria,
        alterarItem: alterarTipoContaBancaria,
        excluirItem: excluirTipoContaBancaria,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_CONTAS_BANCARIAS, paginaPermissao: FUNCIONALIDADES.TIPOS_CONTAS_BANCARIAS, rota: ROUTES.TIPOS_CONTAS_BANCARIAS, services: services });
};
export default TiposContasBancariasEditar;
